const styles = {
  thirdCard: {
    gridColumn: '1 / -1',
    gridRow: 2,
    p: 0.5,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'visible',
  },

  fullScreenCard: {
    position: 'fixed',
    top: '5%',
    left: '5%',
    width: '90vw',
    height: '90vh',
    zIndex: 1299,
    backgroundColor: '#fff',
    borderRadius: 2,
    boxShadow: 24,
    overflow: 'auto',
  },

  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 1.5,
  },

  headerTitle: {
    fontSize: '1rem',
  },

  fullScreenToggleButton: {
    backgroundColor: '#fff',
    color: '#5236AB',
    width: 36,
    height: 36,
    '&:hover': { backgroundColor: '#f5f5f5' },
  },
};

export default styles;
